// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserBanned-space1-OSZOb {
	margin-bottom: 6px !important;
}

.UserBanned-space2-_rfyl {
	margin-bottom: 12px !important;
}

.UserBanned-space3-ZGCEw {
	margin-bottom: 18px !important;
}

.UserBanned-space4-sDTjz {
	margin-bottom: 24px !important;
}

.UserBanned-space5-YuP9N {
	margin-bottom: 30px !important;
}

.UserBanned-space6-RJpy3 {
	margin-bottom: 36px !important;
}

.UserBanned-space7-r0I61 {
	margin-bottom: 42px !important;
}

.UserBanned-space8-sIONt {
	margin-bottom: 48px !important;
}

.UserBanned-spaceTop1-_0mjS {
	margin-top: 6px !important;
}

.UserBanned-spaceTop2-Zg5Cz {
	margin-top: 12px !important;
}

.UserBanned-spaceTop3-rPCye {
	margin-top: 18px !important;
}

.UserBanned-spaceTop4-uuLmC {
	margin-top: 24px !important;
}

.UserBanned-spaceTop5-h92UI {
	margin-top: 30px !important;
}

.UserBanned-spaceTop6-IHiQQ {
	margin-top: 36px !important;
}

.UserBanned-spaceTop7-xbyu1 {
	margin-top: 42px !important;
}

.UserBanned-spaceTop8-CqG6A {
	margin-top: 48px !important;
}

.UserBanned-noMargin-i8UMM {
	margin: 0px !important;
}

.UserBanned-padding1-MAswA {
	padding-bottom: 6px !important;
}

.UserBanned-padding2-ON1dq {
	padding-bottom: 12px !important;
}

.UserBanned-padding3-SSJn9 {
	padding-bottom: 18px !important;
}

.UserBanned-padding4-QWz6l {
	padding-bottom: 24px !important;
}

.UserBanned-padding5-aBaoa {
	padding-bottom: 30px !important;
}

.UserBanned-padding6-y16jA {
	padding-bottom: 36px !important;
}

.UserBanned-padding7-i_bbu {
	padding-bottom: 42px !important;
}

.UserBanned-paddingTop1-lYLQg {
	padding-top: 6px !important;
}

.UserBanned-paddingTop2-_j3JF {
	padding-top: 12px !important;
}

.UserBanned-paddingTop3-cC9HK {
	padding-top: 18px !important;
}

.UserBanned-paddingTop4-6vqd4 {
	padding-top: 24px !important;
}

.UserBanned-paddingTop5-HbO1J {
	padding-top: 30px !important;
}

.UserBanned-paddingTop6-hXOZd {
	padding-top: 36px !important;
}

.UserBanned-paddingTop7-lavkJ {
	padding-top: 42px !important;
}

.UserBanned-noPadding-eyeGn {
	padding: 0px !important;
}

.UserBanned-spaceMarginBottom0-N3OLT {
	margin-bottom: 0;
}

.UserBanned-textBold-WKkMB {
	font-weight: 500 !important;
}

.UserBanned-textBolder-KVL0x {
	font-weight: 700 !important;
}

.UserBanned-textNormal-eU992 {
	font-weight: normal !important;
}

/*New Design Text Colors */

.UserBanned-textDarkBlue-cViOj {
	color: rgb(20, 39, 94) !important;
}

.UserBanned-textLightBlue-Y5WEE {
	color: rgb(57, 87, 106) !important;
}

.UserBanned-textLightSandleGreen-HT88o {
	color: rgb(76, 86, 41) !important;
}

.UserBanned-textLightBrown-zDDPZ {
	color: rgb(115, 79, 33) !important;
}

.UserBanned-textMediumMaroon-yHoWO {
	color: rgb(87, 37, 51) !important;
}

.UserBanned-textBrown-HcN3F {
	color: rgb(160, 47, 24) !important;
}

.UserBanned-textMaroon-rTrq4 {
	color: rgb(155, 49, 67) !important;
}

.UserBanned-textDarkBrown-ohg6R {
	color: rgb(83, 18, 16) !important;
}

.UserBanned-textMediumBrown-qt51T {
	color: rgb(142, 28, 10) !important;
}

.UserBanned-textSkyBlue-hXCWv {
	color: rgb(37, 117, 141) !important;
}

.UserBanned-textGray-F6QIC {
	color: rgb(77, 65, 51) !important;
}

.UserBanned-root-W8tah {
	padding-left: 20px;
	padding-right: 20px;
}

.UserBanned-container-wMtfL {
	margin: 0 auto;
	padding: 0 0 40px;
	max-width: 700px;
}

.UserBanned-textJumbo-sRkwp {
	font-size: 95px;
	font-weight: bold;
	margin: 0;
}

.UserBanned-textMedium-cP_oQ {
	font-size: 50px;
	font-weight: bold;
	margin: 0;
}

.UserBanned-subTitle-OdoQT {
	font-size: 22px;
	color: var(--common-text-color);
	margin-left: 10px;
}

.UserBanned-subText-fvZE2 {
	font-size: 22px !important;
	line-height: normal;
	margin-top: 36px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/routes/userbanned/UserBanned.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1LA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;CAC1B,mBAAmB;CACnB,gBAAgB;AACjB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.root {\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 0 0 40px;\n\tmax-width: 700px;\n}\n\n.textJumbo {\n\tfont-size: 95px;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.textMedium {\n\tfont-size: 50px;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.subTitle {\n\tfont-size: 22px;\n\tcolor: var(--common-text-color);\n\tmargin-left: 10px;\n}\n\n.subText {\n\tfont-size: 22px !important;\n\tline-height: normal;\n\tmargin-top: 36px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `UserBanned-space1-OSZOb`,
	"space2": `UserBanned-space2-_rfyl`,
	"space3": `UserBanned-space3-ZGCEw`,
	"space4": `UserBanned-space4-sDTjz`,
	"space5": `UserBanned-space5-YuP9N`,
	"space6": `UserBanned-space6-RJpy3`,
	"space7": `UserBanned-space7-r0I61`,
	"space8": `UserBanned-space8-sIONt`,
	"spaceTop1": `UserBanned-spaceTop1-_0mjS`,
	"spaceTop2": `UserBanned-spaceTop2-Zg5Cz`,
	"spaceTop3": `UserBanned-spaceTop3-rPCye`,
	"spaceTop4": `UserBanned-spaceTop4-uuLmC`,
	"spaceTop5": `UserBanned-spaceTop5-h92UI`,
	"spaceTop6": `UserBanned-spaceTop6-IHiQQ`,
	"spaceTop7": `UserBanned-spaceTop7-xbyu1`,
	"spaceTop8": `UserBanned-spaceTop8-CqG6A`,
	"noMargin": `UserBanned-noMargin-i8UMM`,
	"padding1": `UserBanned-padding1-MAswA`,
	"padding2": `UserBanned-padding2-ON1dq`,
	"padding3": `UserBanned-padding3-SSJn9`,
	"padding4": `UserBanned-padding4-QWz6l`,
	"padding5": `UserBanned-padding5-aBaoa`,
	"padding6": `UserBanned-padding6-y16jA`,
	"padding7": `UserBanned-padding7-i_bbu`,
	"paddingTop1": `UserBanned-paddingTop1-lYLQg`,
	"paddingTop2": `UserBanned-paddingTop2-_j3JF`,
	"paddingTop3": `UserBanned-paddingTop3-cC9HK`,
	"paddingTop4": `UserBanned-paddingTop4-6vqd4`,
	"paddingTop5": `UserBanned-paddingTop5-HbO1J`,
	"paddingTop6": `UserBanned-paddingTop6-hXOZd`,
	"paddingTop7": `UserBanned-paddingTop7-lavkJ`,
	"noPadding": `UserBanned-noPadding-eyeGn`,
	"spaceMarginBottom0": `UserBanned-spaceMarginBottom0-N3OLT`,
	"textBold": `UserBanned-textBold-WKkMB`,
	"textBolder": `UserBanned-textBolder-KVL0x`,
	"textNormal": `UserBanned-textNormal-eU992`,
	"textDarkBlue": `UserBanned-textDarkBlue-cViOj`,
	"textLightBlue": `UserBanned-textLightBlue-Y5WEE`,
	"textLightSandleGreen": `UserBanned-textLightSandleGreen-HT88o`,
	"textLightBrown": `UserBanned-textLightBrown-zDDPZ`,
	"textMediumMaroon": `UserBanned-textMediumMaroon-yHoWO`,
	"textBrown": `UserBanned-textBrown-HcN3F`,
	"textMaroon": `UserBanned-textMaroon-rTrq4`,
	"textDarkBrown": `UserBanned-textDarkBrown-ohg6R`,
	"textMediumBrown": `UserBanned-textMediumBrown-qt51T`,
	"textSkyBlue": `UserBanned-textSkyBlue-hXCWv`,
	"textGray": `UserBanned-textGray-F6QIC`,
	"root": `UserBanned-root-W8tah`,
	"container": `UserBanned-container-wMtfL`,
	"textJumbo": `UserBanned-textJumbo-sRkwp`,
	"textMedium": `UserBanned-textMedium-cP_oQ`,
	"subTitle": `UserBanned-subTitle-OdoQT`,
	"subText": `UserBanned-subText-fvZE2`
};
module.exports = ___CSS_LOADER_EXPORT___;
